import { createFileRoute } from "@tanstack/react-router";

const Route = createFileRoute("/$pillar/$category/$initiative/")({ component: () => null });

export { Route };
